import SubscriptionPlan from "types/enums/SubscriptionPlan"

export const isPartnersEnabledPlan = (plan?: SubscriptionPlan | string | null): boolean =>
  plan === SubscriptionPlan.E_PLUS || plan === SubscriptionPlan.NETWORK
